import React from "react";
import { Heart } from "lucide-react";
import { useConsumerAuth } from "@/contexts/ConsumerAuthContext";

/**
 * Heart icon button. Works anonymously — favorites land in localStorage.
 * Once the consumer signs in, the local list auto-syncs to the server.
 */
export const FavoriteButton = ({ product, size = "sm" }) => {
  const { isFavorite, toggleFavorite, user } = useConsumerAuth();
  const active = isFavorite(product?.id);
  const big = size === "lg";

  // Soft sign-in nudge: tooltip when the user isn't signed in yet, so they
  // know their save is local-only and can be lifted to "across devices"
  // with an account. No popup, no friction — just a hover affordance.
  const tooltip = active
    ? user
      ? "Remove from saved"
      : "Saved on this device · sign in to keep across devices"
    : user
      ? "Save"
      : "Save · sign in to keep across devices";

  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleFavorite(product);
      }}
      data-testid={`favorite-btn-${product?.id}`}
      aria-label={active ? "Remove from saved" : "Save product"}
      aria-pressed={active}
      title={tooltip}
      className={`group inline-flex items-center justify-center rounded-full backdrop-blur transition-all ${
        big ? "h-10 w-10" : "h-8 w-8"
      } ${
        active
          ? "bg-rose-500/90 text-white shadow-[0_0_20px_rgba(244,63,94,0.45)]"
          : "bg-background/70 text-foreground/70 border border-border hover:text-rose-300 hover:border-rose-400/40"
      }`}
    >
      <Heart
        className={big ? "w-4 h-4" : "w-3.5 h-3.5"}
        strokeWidth={2}
        fill={active ? "currentColor" : "none"}
      />
    </button>
  );
};
